/* ============================================================
   bc-ds.js — Endro Diagnostic Sérums — Liquid LP
   Navigation SPA (hero → diagnostic → result) + utilitaires
   ============================================================ */

/* NB : l'ouverture du diagnostic (bcDsGoStage('diagnostic')) est définie
   inline dans la section quiz (ouverture du modal). On ne la redéfinit PAS
   ici pour ne pas écraser cette fonction (bc-ds.js est chargé en defer,
   donc après le script inline du quiz). */

/* ── Analytics helpers ──────────────────────────────────────── */
var bcDsEvents = {
  ctaClick: function(label) {
    if (window.dataLayer) window.dataLayer.push({ event: 'cta_click', label: label });
  },
  addToCart: function(product, price) {
    if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', product: product, price: price });
  }
};

/* ── Scroll reveals (IntersectionObserver) ──────────────────── */
(function() {
  if (!window.IntersectionObserver) return;

  var reveals = document.querySelectorAll('[data-bc-reveal]');
  if (!reveals.length) return;

  var EASE = 'cubic-bezier(0.25, 1, 0.5, 1)';

  reveals.forEach(function(el) {
    var delay = parseFloat(el.dataset.bcRevealDelay || 0);
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.55s ' + EASE + ' ' + delay + 's, transform 0.55s ' + EASE + ' ' + delay + 's';
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '-40px' });

  reveals.forEach(function(el) { observer.observe(el); });
})();

/* ── Parallax (FinalCTA bg) ─────────────────────────────────── */
(function() {
  var section = document.querySelector('[data-bc-parallax]');
  var img     = section && section.querySelector('[data-bc-parallax-img]');
  if (!section || !img) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var raf = null;
  function update() {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    if (rect.bottom < -100 || rect.top > vh + 100) return;
    var offset = (rect.top + rect.height / 2 - vh / 2) / vh;
    img.style.transform = 'translateY(' + (offset * -120) + 'px)';
  }
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function() { update(); raf = null; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  update();
})();
